// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Invoice_ConfigResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for invoice provider configuration
 */
import type { Invoice_ConfigRow } from './Invoice_ConfigRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Invoice_ConfigResponseDados = Invoice_ConfigRow;

export type Invoice_ConfigResponse = ApiResponse<Invoice_ConfigResponseDados>;

registerResponseContract('Invoice_ConfigResponse', {
  _nullable:              { type: 'boolean', required: false },
  id:                     { type: 'number',  required: false },
  franchise_id:           { type: 'number',  required: false },
  provider_code:          { type: 'string',  required: false },
  sandbox_mode:           { type: 'number',  required: false },
  monthly_emission_limit: { type: 'number',  required: false },
  config:                 { type: 'string',  required: false },
  active:                 { type: 'number',  required: false },
  created_at:             { type: 'string',  required: false },
  updated_at:             { type: 'string',  required: false },
})
